import { Stack } from '@lyearn/ui';
import * as User from '@/components/User';
import { UserFragment } from '@/graphql/fragments/generated/User';

export const renderUserOption = (user: UserFragment) => {
  return (
    <User.Provider alignItems="center" className="flex items-center space-s-12" user={user}>
      <User.ProfilePicture size="large" />
      <Stack direction="col">
        <User.Name />
        <User.UniqueId />
      </Stack>
    </User.Provider>
  );
};

export const renderUserTag = (userItem: UserFragment | string) => {
  // string in case of freeSolo
  const user = typeof userItem === 'string' ? { name: userItem } : userItem;

  return (
    <User.Provider className="flex items-center space-s-6" user={user}>
      <User.ProfilePicture size="x-small" />
      <User.Name />
    </User.Provider>
  );
};
